import React from "react";
import Navbar from "@/components/marketing/Navbar";
import Hero from "@/components/marketing/Hero";
import Marquee from "@/components/marketing/Marquee";
import Features from "@/components/marketing/Features";
import MeetDox from "@/components/marketing/MeetDox";
import HowItWorks from "@/components/marketing/HowItWorks";
import DashboardPreview from "@/components/marketing/DashboardPreview";
import Pricing from "@/components/marketing/Pricing";
import Testimonials from "@/components/marketing/Testimonials";
import FAQ from "@/components/marketing/FAQ";
import ContactSection from "@/components/marketing/ContactSection";
import Footer from "@/components/marketing/Footer";
import { useTrialModal } from "@/context/TrialModalContext";

export default function Landing() {
  const { openTrial } = useTrialModal();
  const goTrial = () => openTrial();
  const openDoxChat = () => {
    // Programmatically open the persistent DoxWidget by simulating a click
    // on its launcher. The widget mounts globally from App.js.
    const btn = document.querySelector('[data-testid="dox-widget-launcher"]');
    if (btn) btn.click();
  };

  return (
    <div className="relative bg-ink text-white overflow-x-hidden">
      <div className="noise-overlay" />
      <Navbar />
      <main className="relative z-[2]">
        <Hero onTrial={goTrial} onTalkToDox={openDoxChat} />
        <Marquee />
        <Features />
        <MeetDox />
        <HowItWorks />
        <DashboardPreview />
        <Pricing onTrial={goTrial} />
        <Testimonials />
        <FAQ />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
